import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CompanyElement } from '../models/company.model';
import { CompanyService } from '../services/company.service';
import { MatPaginator } from '@angular/material/paginator';


const lstDataCompanies: CompanyElement[] = [];

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrl: './companies.component.css'
})

export class CompaniesComponent implements OnInit  {

  private rowClick$  = new Subject<CompanyElement>();

  displayedColumns: string[] = ['id','logo', 'name', 'address_line_1', 'address_line_2', 'city', 'country',
                                'first_contact_person_name', 'first_contact_person_email', 'first_contact_person_phone',
                                'emergency_contact_person_name', 'emergency_contact_person_email' ];

  dataSource = new MatTableDataSource(lstDataCompanies);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  
  constructor(private router: Router, private companyService: CompanyService) { }

  isLoading = false;

  @ViewChild(MatSort)
  sort: MatSort = new MatSort;

  items: any = [];

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.paginator._intl.itemsPerPageLabel="Registros por página";
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.rowClick$.subscribe(
      row => console.log('[row clicked]', row)
    );
    this.isLoading = true;
    this.loadCompanies();
    this.isLoading = false;
  }

  loadCompanies():void {
    const req=this.companyService.getAllCompanies();
    req.subscribe({
      next: (res) => {
        this.items = res;
        this.dataSource.data=this.items.data;
      },
      error: (e) => {
        console.error(e);
        let msg = e.error.message;
      },
    });
  }

  onRowClicked(row: CompanyElement): void {
    this.rowClick$.next(row);
    this.router.navigate(['company'], { queryParams: { id: row.id } });
  }

}
